import { render, staticRenderFns } from "./exLayout.vue?vue&type=template&id=09c50dea&scoped=true&"
import script from "./exLayout.vue?vue&type=script&lang=js&"
export * from "./exLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c50dea",
  null
  
)

export default component.exports